import { GeneralStyle } from '@website-builder/model/style/general-style';

export class ButtonStyle extends GeneralStyle {
  fullWidth = '';
  columnGap = '';
  rowGap = '';
  centerHorizontally = '';

  static normalize(styles: Partial<ButtonStyle>): ButtonStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const pureStyles = new ButtonStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.fullWidth = styles.fullWidth ?? pureStyles.fullWidth;
    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.rowGap = styles.rowGap ?? pureStyles.rowGap;
    pureStyles.centerHorizontally = styles.centerHorizontally ?? pureStyles.centerHorizontally;

    return pureStyles;
  }
}
